import { render, staticRenderFns } from "./specialGroupDialog.vue?vue&type=template&id=04cde001&"
import script from "./specialGroupDialog.vue?vue&type=script&lang=js&"
export * from "./specialGroupDialog.vue?vue&type=script&lang=js&"
import style0 from "./specialGroupDialog.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports